import { AuthEffects } from './auth-effects';
import { DashboardEffects } from './dashboard-effects';
import { ColumnConfigEffects } from './column-config-effects';
import { SourcesEffects } from './sources-effects';
import { RuleTypesEffects } from './rule-types-effects';
import { RulesEffects } from './rules-effects';

export const effects = [
    AuthEffects, DashboardEffects, ColumnConfigEffects, SourcesEffects, RuleTypesEffects, RulesEffects
];
